module.exports = __webpack_public_path__ + "static/davies-logo-8eabb5de297134c7c8f8977dc6a787de.jpg";